var path = 'areas/projects/actions/docker_network/Octopus.DockerNetwork_summary.html';
var html = "<p> Create a Docker Network <span ng-show=isSingleStep>on machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_network/Octopus.DockerNetwork_summary.html
// module id = 6450380071718065
// module chunks = 1